import axios from "../axios-control";

export const todos = () => axios
    .get('/tipos-de-jornada')
    .then(res => res.data)
    .catch(e => {
      if (e.response.status !== 401) {
        throw(e);
      }
    });

export const cargaUno = id => axios
    .get(`/tipos-de-jornada/${id}`)
    .then(res => res.data)
    .catch(e => {
      if (e.response.status !== 401) {
        throw(e);
      }
    });

export const actualiza = tipo => axios
    .put(`/tipos-de-jornada/${tipo.id}`, tipo)
    .then(res => res.data)
    .catch(e => {
      if (e.response.status !== 401) {
        throw(e);
      }
    });

export const crea = tipo => axios
    .post(`/tipos-de-jornada`, tipo)
    .then(res => res.data)
    .catch(e => {
      if (e.response.status !== 401) {
        throw(e);
      }
    });

export const eliminar = tipo => axios
    .delete(`/tipos-de-jornada/${tipo.id}`)
    .catch(e => {
      if (e.response.status !== 401) {
        throw(e);
      }
    });